export default {"src":"/_next/static/media/tiktok.8ed84cdc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};